// extracted by mini-css-extract-plugin
export default {"root":"warning-verification_root__lWi54"};